document.addEventListener('change', function (e) {
  if (e.target.matches('.facet-options-list-item input[type="checkbox"]')) {
    var wrapper = e.target.closest('collapsible-expandable');
    if (wrapper) {
      var toggleBtn = wrapper.querySelector('.facet-toggle');
      if (toggleBtn && toggleBtn.getAttribute('aria-expanded') === 'true') {
        toggleBtn.click(); // existing close logic trigger karega
      }
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {

  const searchForm = document.querySelector('.custom-search-form');
  const searchInput = document.querySelector('.custom-search-input');

  if (!searchForm || !searchInput) {
    console.log('Search form or input not found');
    return;
  }

  /*
   * =========================================================
   * SETTINGS
   * =========================================================
   */

  const MAX_PAGES = 100;

  /*
   * Number of pages to load at the same time.
   *
   * Keep this around 2-3 to reduce Shopify 429 errors.
   */
  const CONCURRENT_REQUESTS = 3;

  /*
   * Delay between batches.
   */
  const BATCH_DELAY = 300;

  /*
   * Products per Shopify page.
   */
  const PRODUCTS_PER_PAGE = 24;


  /*
   * =========================================================
   * VARIABLES
   * =========================================================
   */

  let productCache = [];

  let loadedPages = new Set();

  let loadingPages = new Set();

  let indexingStarted = false;

  let indexingFinished = false;

  let searchActive = false;

  let searchTimer = null;

  let originalProductHTML = '';

  let originalPaginationHTML = '';

  let originalPageSaved = false;


  /*
   * =========================================================
   * GET PRODUCT CONTAINER
   * =========================================================
   */

  function getContainer() {

    return document.querySelector(
      '#ProductGridContainer'
    );

  }


  /*
   * =========================================================
   * GET PRODUCT GRID
   * =========================================================
   */

  function getProductGrid() {

    const container = getContainer();

    if (!container) {
      return null;
    }

    return container.querySelector(
      '#product-grid'
    );

  }


  /*
   * =========================================================
   * SAVE ORIGINAL PAGE
   * =========================================================
   */

  function saveOriginalPage() {

    if (originalPageSaved) {
      return;
    }

    const container = getContainer();

    const grid = getProductGrid();

    if (!container || !grid) {
      return;
    }

    /*
     * Save Page 1 product HTML.
     */
    originalProductHTML =
      grid.innerHTML;


    /*
     * Save original pagination.
     */
    const pagination =
      container.querySelector(
        '.pagination'
      );

    if (pagination) {

      originalPaginationHTML =
        pagination.outerHTML;

    }


    originalPageSaved = true;

  }


  /*
   * =========================================================
   * GET PAGE URL
   * =========================================================
   */

  function getPageURL(page) {

    const url =
      new URL(
        window.location.href
      );

    url.searchParams.set(
      'page',
      page
    );

    /*
     * Remove AJAX view parameter if present.
     */
    url.searchParams.delete(
      'view'
    );

    return url.toString();

  }


  /*
   * =========================================================
   * EXTRACT PRODUCTS
   * =========================================================
   */

  function extractProducts(html) {

    const parser =
      new DOMParser();

    const doc =
      parser.parseFromString(
        html,
        'text/html'
      );

    const grid =
      doc.querySelector(
        '#product-grid'
      );

    if (!grid) {
      return [];
    }

    return Array.from(
      grid.querySelectorAll(
        '.grid-item'
      )
    );

  }


  /*
   * =========================================================
   * CREATE PRODUCT CACHE
   * =========================================================
   */

  function createProductCache(product) {

    return {

      /*
       * Store complete product HTML.
       */
      html:
        product.outerHTML,

      /*
       * Store searchable text.
       *
       * This means we don't need to run
       * textContent every time the user searches.
       */
      text:
        product.textContent
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()

    };

  }


  /*
   * =========================================================
   * CACHE PAGE
   * =========================================================
   */

  function cachePage(
    page,
    products
  ) {

    /*
     * Don't cache same page twice.
     */
    if (
      loadedPages.has(page)
    ) {
      return;
    }


    products.forEach(
      function (product) {

        productCache.push(
          createProductCache(
            product
          )
        );

      }
    );


    loadedPages.add(page);


    console.log(
      'Cached page:',
      page,
      '| Products:',
      products.length,
      '| Total cached:',
      productCache.length
    );

  }


  /*
   * =========================================================
   * CACHE PAGE 1
   * =========================================================
   */

  function cacheFirstPage() {

    saveOriginalPage();


    const temp =
      document.createElement(
        'div'
      );

    temp.innerHTML =
      originalProductHTML;


    const products =
      Array.from(
        temp.querySelectorAll(
          '.grid-item'
        )
      );


    cachePage(
      1,
      products
    );


    console.log(
      'Page 1 cached:',
      products.length
    );

  }


  /*
   * =========================================================
   * LOAD ONE PAGE
   * =========================================================
   */

  async function loadPage(page) {

    /*
     * Don't request same page twice.
     */
    if (
      loadedPages.has(page) ||
      loadingPages.has(page)
    ) {

      return {
        page: page,
        products: [],
        skipped: true
      };

    }


    loadingPages.add(page);


    try {

      console.log(
        'Loading page:',
        page
      );


      const response =
        await fetch(
          getPageURL(page),
          {
            method: 'GET',

            credentials:
              'same-origin',

            headers: {

              'X-Requested-With':
                'XMLHttpRequest',

              'Accept':
                'text/html'

            }
          }
        );


      /*
       * Shopify rate limit.
       */
      if (
        response.status === 429
      ) {

        console.log(
          '429 received for page:',
          page
        );


        loadingPages.delete(page);


        return {

          page: page,

          products: [],

          rateLimited: true

        };

      }


      /*
       * Other HTTP error.
       */
      if (!response.ok) {

        console.log(
          'Failed page:',
          page,
          'Status:',
          response.status
        );


        loadingPages.delete(page);


        return {

          page: page,

          products: [],

          failed: true

        };

      }


      const html =
        await response.text();


      if (!html) {

        loadingPages.delete(page);

        return {

          page: page,

          products: [],

          failed: true

        };

      }


      /*
       * Extract products.
       */
      const products =
        extractProducts(
          html
        );


      /*
       * Add products to cache.
       */
      cachePage(
        page,
        products
      );


      loadingPages.delete(page);


      return {

        page: page,

        products: products,

        success: true

      };


    } catch (error) {

      console.error(
        'Error loading page:',
        page,
        error
      );


      loadingPages.delete(page);


      return {

        page: page,

        products: [],

        failed: true

      };

    }

  }


  /*
   * =========================================================
   * BACKGROUND LOAD ALL PRODUCTS
   * =========================================================
   */

  async function loadAllProductsInBackground() {

    /*
     * Prevent duplicate indexing.
     */
    if (indexingStarted) {
      return;
    }


    indexingStarted = true;


    console.log(
      '===================================='
    );

    console.log(
      'STARTING BACKGROUND PRODUCT LOADING'
    );

    console.log(
      '===================================='
    );


    /*
     * Cache current Page 1 first.
     */
    cacheFirstPage();


    let nextPage = 2;

    let reachedLastPage = false;


    /*
     * Continue until all pages are loaded.
     */
    while (
      nextPage <= MAX_PAGES &&
      !reachedLastPage
    ) {


      /*
       * Create batch.
       *
       * Example:
       *
       * Batch 1 = 2,3,4
       * Batch 2 = 5,6,7
       * Batch 3 = 8,9,10
       */
      const pages = [];


      for (
        let i = 0;

        i < CONCURRENT_REQUESTS &&
        nextPage <= MAX_PAGES;

        i++
      ) {

        pages.push(
          nextPage
        );

        nextPage++;

      }


      console.log(
        'Loading batch:',
        pages
      );


      /*
       * Load pages simultaneously.
       */
      const results =
        await Promise.all(
          pages.map(
            function (page) {

              return loadPage(
                page
              );

            }
          )
        );


      /*
       * Check results.
       */
      results.forEach(
        function (result) {

          /*
           * Empty page = end.
           */
          if (
            result.success &&
            result.products.length === 0
          ) {

            reachedLastPage = true;

          }


          /*
           * If page contains fewer
           * products than normal page size,
           * it is probably the final page.
           */
          if (
            result.success &&
            result.products.length > 0 &&
            result.products.length <
              PRODUCTS_PER_PAGE
          ) {

            reachedLastPage = true;

          }

        }
      );


      /*
       * If Shopify returns 429,
       * wait before next batch.
       */
      const has429 =
        results.some(
          function (result) {

            return result.rateLimited;

          }
        );


      if (has429) {

        console.log(
          'Shopify rate limit detected.'
        );

        console.log(
          'Waiting before retry...'
        );


        /*
         * Retry pages which were rate limited.
         */
        const retryPages =
          results
            .filter(
              function (result) {

                return result.rateLimited;

              }
            )
            .map(
              function (result) {

                return result.page;

              }
            );


        await delay(
          2000
        );


        /*
         * Put rate-limited pages
         * back into the queue.
         */
        for (
          let i = retryPages.length - 1;
          i >= 0;
          i--
        ) {

          nextPage--;

        }

      }
      else {

        await delay(
          BATCH_DELAY
        );

      }

    }


    indexingFinished = true;


    console.log(
      '===================================='
    );

    console.log(
      'BACKGROUND PRODUCT LOADING FINISHED'
    );

    console.log(
      'Total products:',
      productCache.length
    );

    console.log(
      'Total pages:',
      loadedPages.size
    );

    console.log(
      '===================================='
    );


    /*
     * If user is currently searching,
     * search again using complete cache.
     */
    if (
      searchActive &&
      searchInput.value.trim() !== ''
    ) {

      performSearch(
        searchInput.value.trim()
      );

    }

  }


  /*
   * =========================================================
   * DELAY
   * =========================================================
   */

  function delay(ms) {

    return new Promise(
      function (resolve) {

        setTimeout(
          resolve,
          ms
        );

      }
    );

  }


  /*
   * =========================================================
   * HIDE PAGINATION
   * =========================================================
   */

  function hidePagination() {

    const container =
      getContainer();

    if (!container) {
      return;
    }


    const pagination =
      container.querySelector(
        '.pagination'
      );


    if (pagination) {

      pagination.style.display =
        'none';

    }

  }


  /*
   * =========================================================
   * RESTORE PAGINATION
   * =========================================================
   */

  function restorePagination() {

    const container =
      getContainer();

    if (!container) {
      return;
    }


    let pagination =
      container.querySelector(
        '.pagination'
      );


    if (pagination) {

      pagination.style.display =
        '';

    }
    else if (
      originalPaginationHTML
    ) {


      /*
       * Use DOM parser instead of
       * insertAdjacentHTML to avoid
       * nesting/Node errors.
       */
      const temp =
        document.createElement(
          'div'
        );


      temp.innerHTML =
        originalPaginationHTML;


      const newPagination =
        temp.firstElementChild;


      if (newPagination) {

        container.appendChild(
          newPagination
        );

      }

    }

  }


  /*
   * =========================================================
   * LOADER
   * =========================================================
   */

  function getLoader() {

    const container =
      getContainer();

    if (!container) {
      return null;
    }


    let loader =
      container.querySelector(
        '.custom-search-loader'
      );


    if (!loader) {

      loader =
        document.createElement(
          'div'
        );


      loader.className =
        'custom-search-loader';


      loader.innerHTML = `

        <div class="custom-search-loader-inner">

          <div class="custom-search-spinner"></div>

          <div class="custom-search-loading-text">
            Searching products...
          </div>

        </div>

      `;


      container.appendChild(
        loader
      );

    }


    return loader;

  }


  function showLoader(
    message
  ) {

    const loader =
      getLoader();


    if (!loader) {
      return;
    }


    const text =
      loader.querySelector(
        '.custom-search-loading-text'
      );


    if (text) {

      text.textContent =
        message ||
        'Searching products...';

    }


    loader.classList.add(
      'active'
    );

  }


  function hideLoader() {

    const loader =
      getLoader();


    if (!loader) {
      return;
    }


    loader.classList.remove(
      'active'
    );

  }


  /*
   * =========================================================
   * NO RESULTS
   * =========================================================
   */

  function removeNoResults() {

    const container =
      getContainer();

    if (!container) {
      return;
    }


    const noResults =
      container.querySelector(
        '.custom-no-search-results'
      );


    if (noResults) {

      noResults.remove();

    }

  }


  function showNoResults(
    value
  ) {

    const container =
      getContainer();

    if (!container) {
      return;
    }


    let noResults =
      container.querySelector(
        '.custom-no-search-results'
      );


    if (!noResults) {

      noResults =
        document.createElement(
          'div'
        );


      noResults.className =
        'custom-no-search-results';


      container.appendChild(
        noResults
      );

    }


    noResults.innerHTML =
      '<p>No products found for <strong>"' +
      escapeHTML(value) +
      '"</strong></p>';


    noResults.style.display =
      'block';

  }


  /*
   * =========================================================
   * SEARCH PRODUCTS FROM CACHE
   * =========================================================
   */

  function performSearch(
    searchValue
  ) {

    const grid =
      getProductGrid();


    if (!grid) {
      return;
    }


    searchValue =
      searchValue
        .trim()
        .toLowerCase();


    /*
     * Empty search.
     */
    if (!searchValue) {

      restoreOriginalPage();

      return;

    }


    searchActive = true;


    hidePagination();

    removeNoResults();


    /*
     * Search cached products.
     */
    const matches =
      productCache.filter(
        function (product) {

          return product.text.includes(
            searchValue
          );

        }
      );


    console.log(
      '================================'
    );

    console.log(
      'SEARCH:',
      searchValue
    );

    console.log(
      'CACHED PRODUCTS:',
      productCache.length
    );

    console.log(
      'MATCHING PRODUCTS:',
      matches.length
    );

    console.log(
      '================================'
    );


    /*
     * Display matches.
     */
    if (
      matches.length > 0
    ) {


      grid.innerHTML =
        matches
          .map(
            function (product) {

              return product.html;

            }
          )
          .join('');


    }
    else {

      grid.innerHTML = '';


      /*
       * Don't show "No products found"
       * while background indexing is
       * still running.
       */
      if (
        indexingFinished
      ) {

        showNoResults(
          searchValue
        );

      }

    }


    /*
     * If background indexing is still
     * running, show loader.
     */
    if (
      !indexingFinished
    ) {


      showLoader(
        'Searching more products...'
      );


    }
    else {

      hideLoader();

    }

  }


  /*
   * =========================================================
   * RESTORE ORIGINAL PAGE
   * =========================================================
   */

  function restoreOriginalPage() {

    searchActive = false;


    const grid =
      getProductGrid();


    if (!grid) {
      return;
    }


    /*
     * Restore Page 1.
     */
    if (
      originalProductHTML
    ) {

      grid.innerHTML =
        originalProductHTML;

    }


    /*
     * Restore pagination.
     */
    restorePagination();


    removeNoResults();

    hideLoader();


    console.log(
      'Search cleared.'
    );

  }


  /*
   * =========================================================
   * ESCAPE HTML
   * =========================================================
   */

  function escapeHTML(
    value
  ) {

    const div =
      document.createElement(
        'div'
      );


    div.textContent =
      value;


    return div.innerHTML;

  }


  /*
   * =========================================================
   * SEARCH INPUT
   * =========================================================
   */

  searchInput.addEventListener(
    'input',
    function () {

      clearTimeout(
        searchTimer
      );


      const value =
        searchInput.value.trim();


      /*
       * Search cleared.
       */
      if (!value) {

        restoreOriginalPage();

        return;

      }


      /*
       * Very small debounce.
       */
      searchTimer =
        setTimeout(
          function () {

            performSearch(
              value
            );

          },
          100
        );

    }
  );


  /*
   * =========================================================
   * FORM SUBMIT
   * =========================================================
   */

  searchForm.addEventListener(
    'submit',
    function (event) {

      event.preventDefault();


      clearTimeout(
        searchTimer
      );


      const value =
        searchInput.value.trim();


      if (!value) {

        restoreOriginalPage();

        return;

      }


      performSearch(
        value
      );

    }
  );


  /*
   * =========================================================
   * INITIALIZATION
   * =========================================================
   */

  /*
   * Save Page 1 before anything changes.
   */
  saveOriginalPage();


  /*
   * Cache Page 1 immediately.
   */
  cacheFirstPage();


  /*
   * Start loading ALL OTHER PAGES
   * in the background.
   *
   * No loader is shown.
   *
   * The customer can continue
   * using the page normally.
   */
  setTimeout(
    function () {

      loadAllProductsInBackground();

    },
    100
  );


});






